import { atom } from 'jotai';

export interface LastClickedRow {
  rowId: string;
  wasSelected: boolean;
}

export const lastClickedRowState = atom<LastClickedRow | null>(null);
